var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyephar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#004276"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 6.2998C8.20156 6.2998 4.90156 8.6998 3.60156 11.9998C4.90156 15.3998 8.20156 17.6998 12.0016 17.6998C15.8016 17.6998 19.1016 15.2998 20.4016 11.9998C19.1016 8.5998 15.8016 6.2998 12.0016 6.2998ZM12.0016 15.7998C9.90156 15.7998 8.20156 14.0998 8.20156 11.9998C8.20156 9.8998 9.90156 8.1998 12.0016 8.1998C14.1016 8.1998 15.8016 9.8998 15.8016 11.9998C15.8016 14.0998 14.1016 15.7998 12.0016 15.7998ZM12.0016 9.6998C10.7016 9.6998 9.70156 10.6998 9.70156 11.9998C9.70156 13.2998 10.7016 14.2998 12.0016 14.2998C13.3016 14.2998 14.3016 13.2998 14.3016 11.9998C14.3016 10.6998 13.3016 9.6998 12.0016 9.6998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyephar);
export default __webpack_public_path__ + "static/media/eyephar.780ccb03b583a6ac1f6112a38df5ede0.svg";
export { ForwardRef as ReactComponent };